import { useCircleAIShellStore } from "@circle-react-uikit/CircleAIAppShell/store/circleAIShellStore";
import { useIsCircleAiEnabled } from "@circle-react/components/CircleAi/useCircleAiFeatureFlags";
import { useIsCommunityAdmin } from "@circle-react/contexts/punditUserContext";

import { useRecentChatsList } from "../Home/RecentChatsDrawer/useRecentChatsList";
import { CircleAIDockNavCollapsed } from "./CircleAIDockNavCollapsed";
import { CircleAIDockNavExpanded } from "./CircleAIDockNavExpanded";
import { CircleAIDockRecentChatsFlyover } from "./CircleAIDockRecentChatsFlyover";
import { RECENT_CHATS_FETCH_LIMIT } from "./CircleAIDockRecentChatsSectionContent";

export const CircleAIDockNav = () => {
  const isAdmin = useIsCommunityAdmin();
  const isCircleAiEnabled = useIsCircleAiEnabled();
  const dockMode = useCircleAIShellStore(s => s.dockMode);
  const shouldShowRecentChats = isAdmin && isCircleAiEnabled;

  useRecentChatsList({
    query: "",
    perPage: RECENT_CHATS_FETCH_LIMIT,
    enabled: shouldShowRecentChats,
  });

  return (
    <>
      {dockMode === "collapsed" ? (
        <CircleAIDockNavCollapsed />
      ) : (
        <CircleAIDockNavExpanded />
      )}
      {/* Shared recent-chats slider opened by both the expanded "More" button
          and the collapsed clock icon. */}
      {shouldShowRecentChats && <CircleAIDockRecentChatsFlyover />}
    </>
  );
};
